import http from 'utils/http';
import { generateURLWithParams } from 'utils';

export const fetchMenusByMerchantId = (merchantId) => http.get(generateURLWithParams(`v1/restaurants/${merchantId}/menus/`, {
  query: '{id,name,position,is_active,active_hours,migration_driver}',
  include_all_menus_for_management: 'true',
})).then((res) => res.data);

export const fetchMenusById = (menuId) => http.get(generateURLWithParams(`v1/menus/${menuId}/`, {
  query: '{id,migration_driver,active_hours,description,name,images,is_active,categories{id,name,featured,description,position,is_active,items},are_item_images_visible,placeholder_image}',
  skip_modifiers: 'true',
})).then((res) => res.data);
